import SandhillsImage from "@Components/Shared/Controls/SandhillsImage";

const WhiteLabelHeader = (props) => {
    return (
        <div id='listings-company-branding'>
            {props.LogoUrl && <SandhillsImage src={props.LogoUrl} alt={props.DealerName ? props.DealerName : ''} />}
            {props.DealerName && <strong>{props.DealerName}</strong>}
        </div>
    );
};

export default WhiteLabelHeader;
global.WhiteLabelHeader = WhiteLabelHeader;